import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Number = (props) => {

  let inputClass = 'c-personalizer-group__number'

  if (props.touched && !props.valid) {
    inputClass = 'c-personalizer-group__number c-personalizer-group__error'
  }

  return (
    <div className="c-personalizer-group">
      <input type="number" min="0" className={inputClass} {...props} />
      <p class="c-personalizer-group__error-message">{ props.error }</p>
    </div>
  )
}

export default Number



// WEBPACK FOOTER //
// ./src/js/personalizer/components/input/Number.js